var resolveConfigObjects = require('./lib/util/resolveConfig')["default"];

var defaultConfig = require('./stubs/defaultConfig.stub.js');

module.exports = function resolveConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }

  return resolveConfigObjects([].concat(configs, [defaultConfig]));
};